<template>
  <AtomLink
    :url="cta.button.url"
    :target="cta.button.openInNewTab ? '_blank' : '_self'"
    class="flex flex-col w-full h-full cursor-pointer rounded-br-none rounded-lg overflow-hidden md:rounded-xl"
  >
    <MoleculePicture v-if="cta.image" :image="cta.image" :fallback="true" class="v-hover-zoom-image w-full aspect-video min-h-0 object-cover transform transition duration-200" />
    <div class="z-10 px-6 py-6 w-full bg-white rounded-b-xl border-app-green border-b-2 border-r-0 flex flex-col flex-grow">
      <h3 v-if="cta.title" class="mb-2 text-xl font-bold leading-none uppercase">{{ cta.title }}</h3>
      <p v-if="cta.caption" class="text-lg">{{ cta.caption }}</p>
      <p v-if="cta.button.label" class="underline decoration-app-green font-bold mt-auto pt-4 text-lg">
        {{ cta.button.label }}<AtomIconArrowRight class="inline-block w-3 ml-2 text-app-green" />
      </p>
    </div>
  </AtomLink>
</template>

<script setup lang="ts">
interface Props {
  cta: {
    title?: string
    caption?: string
    image?: any
    button: { url: string; label?: string; openInNewTab?: boolean }
  }
}
defineProps<Props>()
</script>
